import { resetEntityImpressionId } from '~/client/store/analytics/entityImpressionId'
import { galleryImpressionsTrackingSelectorFactory } from '~/client/store/analytics/reducer'
import { ThunkDispatch } from 'client/store/interface'
import { AnalyticsNames } from 'shared/constants'

export const trackDirectQVDismissImpression =
  (designId: string, analytics: Gallery.Analytics.IAnalytics) => (_dispatch: ThunkDispatch, getState: () => State.GlobalState) => {
    resetEntityImpressionId(designId)
    const selectImpressions = galleryImpressionsTrackingSelectorFactory()
    const impression = selectImpressions(getState(), analytics, AnalyticsNames.DesignTile)
    analytics.trackImpression(impression)
  }
